/**
 * Sum a per-unit figure across the dialog's units, all-or-nothing: one unit
 * without a number makes the whole total `undefined`. A partial sum would mix
 * priced and unpriced units and read as a real total.
 *
 * `fallback` stands in per unit when the map has no entry — used for the live
 * price, where the catalog price is a reasonable stand-in, but deliberately not
 * for the pre-discount original, where the catalog price is a different figure
 * and would understate the strike.
 */
export const sumPerUnit = (
  guestMixKeys: string[],
  valueByMixKey: Map<string, number | undefined>,
  fallback?: number,
): number | undefined =>
  guestMixKeys.reduce<number | undefined>((sum, key) => {
    if (sum === undefined) return undefined;
    const resolved = valueByMixKey.get(key) ?? fallback;
    if (typeof resolved !== "number") return undefined;
    return sum + resolved;
  }, 0);
